import React, { FC } from 'react';

import FaqSection from '@rover/components/src/FaqSection';
import LandingFaqList, {
  LandingFaqItem,
} from '@rover/react-lib/src/pages/landing/components/LandingFaq/LandingFaqList';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

type Props = {
  locationName: string;
};

const GroomingFaqList: FC<Props> = ({ locationName }) => {
  const brandDisplayName = getBrandDisplayName();

  // Grooming's FAQs are authored here rather than read from `BrandLocalityServiceFAQ`, because
  // grooming localities carry no FAQ rows. The answers are the same for every locality, so the
  // location only ever appears as an interpolated name.
  // DEV-156190: Translate
  const faqs: LandingFaqItem[] = [
    {
      question: `How do groomers in ${locationName} get approved to list on Rover?`,
      answer: `Groomers listing on Rover complete a grooming profile that Rover reviews and approves, and they pass a background check before they can offer grooming in ${locationName}.`,
    },
    {
      question: `What grooming services can I book in ${locationName}?`,
      answer: `Groomers on Rover offer a bath and brush, a full-service groom, or both. A bath and brush covers washing, drying, and brushing out the coat. A full-service groom adds a haircut and styling. Each groomer lists the services and prices they offer on their profile.`,
    },
    {
      question: `Does the groomer come to me, or do I go to them?`,
      answer: `Both options exist in ${locationName}. Some groomers work from their own space and have you drop your pet off. Others travel to you and groom your pet at your home. Each profile shows which of the two that groomer offers.`,
    },
    {
      question: `Will a groomer in ${locationName} take my size of dog?`,
      answer: `Groomers set the pet sizes they accept, because coat type and size change how long a groom takes and what equipment it needs. Each profile lists the sizes that groomer works with, so you can check before you get in touch.`,
    },
    {
      question: `How do I contact a groomer in ${locationName}?`,
      answer: `Open the groomer's profile and select the contact button. You can message more than one groomer. Nothing is booked until you and the groomer both agree to go ahead.`,
    },
  ];

  return (
    <LandingFaqList faqs={faqs} mt="16x" mb="8x">
      <FaqSection.Header variant="heading" webProps={{ responsive: false }}>
        {/* DEV-156190: Translate */}
        {`Pet grooming FAQs - ${locationName}`}
      </FaqSection.Header>
      <FaqSection.Subheader>
        {/* DEV-156190: Translate */}
        {`Frequently asked questions about ${brandDisplayName}`}
      </FaqSection.Subheader>
    </LandingFaqList>
  );
};

export default GroomingFaqList;
